<template>
  <div class='InputCaracter'>
    <input-caracter-item
    v-for="(data, key) in itens"
    :key="key"
    :data="data"
    />
  </div>
</template>

<script>
import InputCaracterItem from './InputCaracterItem'
export default {
  name: 'InputCaracter',
  components: { InputCaracterItem },
  data () {
    return {
      itens: [
        { icon: 'LocationIcon', placeholder: 'Endereço' },
        { icon: 'RoomsIcon', placeholder: 'Quartos' },
        { icon: 'ToiletIcon', placeholder: 'Banheiros' },
        { icon: 'ParkingIcon', placeholder: 'Vagas' },
        { icon: 'AreaIcon', placeholder: 'Área' }
      ]
    }
  }
}
</script>

<style scoped>
.InputCaracter {
  width: 100%;
}
</style>
